import React from 'react'
import { Button, Space } from 'hljd'
import { ExclamationCircleFilled } from '@ant-design/icons'
import SortAreaUpload from '../SortUpload/Area'
import Selecter from '../SortUpload/Selecter'
import Sorter from '../Sorter'
import styles from './style.module.less'
import { areaList } from './constant'
const dpr = window.devicePixelRatio

export const TitleBar = ({
  title,
  errType,
  btnText,
  keyName = '',
  hasSelect,
  onAreaSet,
  toggleMode,
  selectMode
}) => {
  return (
    <div className={styles.titleBar}>
      <div
        className="txt"
        style={{
          color: errType ? '#FF4B4B' : '#333'
        }}
      >
        {errType && (
          <ExclamationCircleFilled
            style={{
              color: '#FF4B4B',
              fontSize: 16,
              marginRight: 5
            }}
          />
        )}
        {title}
      </div>
      <div className="btnGrp">
        {selectMode && (
          <Space size={6}>
            {areaList.map(
              ({ title, key }) =>
                keyName === key ? (
                  ''
                ) : (
                  <Button
                    key={key}
                    onClick={() => onAreaSet(key)}
                    disabled={!hasSelect}
                  >
                    {title}
                  </Button>
                )
            )}

            <Button onClick={() => toggleMode(false)} type="primary">
              完成
            </Button>
          </Space>
        )}
        {!selectMode && (
          <Button onClick={() => toggleMode(true)}>{btnText}</Button>
        )}
      </div>
    </div>
  )
}

export const Item = ({
  keyName,
  title = '',
  max,
  maxSize,
  maxHeight,
  maxWidth,
  value = [],
  selected = [],
  mask = false,
  selectMode = false,
  onChange = () => {},
  onLoad = () => {},
  toggleMode = () => {},
  onSelect = () => {},
  onAreaSet = () => {}
}) => {
  const hasSelect = selected.length > 0
  return (
    <div className={styles.group}>
      <TitleBar
        keyName={keyName}
        title={title}
        btnText="调整婚礼区域"
        hasSelect={hasSelect}
        onAreaSet={onAreaSet}
        toggleMode={toggleMode}
        selectMode={selectMode}
      />
      <SortAreaUpload
        selectMode={selectMode}
        maxWidth={maxWidth}
        maxHeight={maxHeight}
        maxSize={maxSize}
        max={max + value.length}
        value={value}
        selected={selected}
        onSelect={onSelect}
        onChange={onChange}
        onLoad={onLoad}
      />
      {mask && <div className="mask" />}
    </div>
  )
}

export const GlobalItem = ({
  title = '',
  value = [],
  selected = [],
  selectMode = false,
  mask = false,
  onChange = () => {},
  toggleMode = () => {},
  onSelect = () => {},
  onAreaSet = () => {}
}) => {
  const hasSelect = selected.length > 0
  const onDelete = item => {
    const newData = value.filter(e => {
      if (e?.id && item?.id) {
        return e?.id !== item?.id
      } else if (e?.uid && item?.uid) {
        return e?.uid !== item?.uid
      } else {
        return e?.url !== item?.url
      }
    })
    onChange(newData)
  }

  return (
    <div className={styles.group}>
      <TitleBar
        title={title}
        errType={true}
        btnText="去设置"
        hasSelect={hasSelect}
        onAreaSet={onAreaSet}
        toggleMode={toggleMode}
        selectMode={selectMode}
      />
      {selectMode && (
        <Selecter value={value} selected={selected} onSelect={onSelect} />
      )}
      {!selectMode && (
        <Sorter
          onSortEnd={e => onChange(e)}
          data={value}
          render={item => (
            <div
              className={styles.item}
              style={{
                width: 120,
                height: 120,
                backgroundImage: `url("${item?.url}?imageView2/2/w/${Math.round(
                  120 * dpr
                )}/h/${Math.round(120 * dpr)}")`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                borderColor: '#FF4B4B'
              }}
            >
              <div className={styles.close} onClick={() => onDelete(item)} />
            </div>
          )}
        />
      )}
      {mask && <div className="mask" />}
    </div>
  )
}
